import { EyeIcon, SearchIcon } from "assets/images/common/svgs";
import DataNotFound from "components/particles/table/data-not-found";
import Pagination from "components/particles/table/pagination";
import useUsers from "containers/user-management/useHooks";
import { useDebounce } from "hooks/useDebounce";
import useStore from "hooks/useStore";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import { ROLES } from "utils/helpers/enums/roles.enum";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { AmbassadorExperienceFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import { UserDTO } from "utils/helpers/models/users/user.dto";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { USER_STATUSES } from "utils/helpers/enums/shared.enum";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";

interface EventMedia {
  id: number;
  name: string;
  mimeType: string;
  userId: number | null;
  createdAt: string;
  updatedAt: string;
}

const AmbassadorExperiencesListing = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const { getAmbassadorExperiences, activateUser, deactivateUser } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [filters, setFilters] = useState<AmbassadorExperienceFiltersDTO>(new AmbassadorExperienceFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);
  const debounceSearch = useDebounce(filters.nameOrEmail, 1000);
  const columns: string[] = [
    "Image",
    "Event Name",
    "Description",
    "Event Type",
    "Date",
    "Time",
    "Participants",
    "Action",
  ];

  const buildUpdatedFilters = (
    updates: Partial<AmbassadorExperienceFiltersDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 1;
    }
    return updatedFilters;
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = buildUpdatedFilters(
      { limit: limit, page: page + 1 },
      false
    );
    setFilters(updatedFilters);
    getAmbassadors(updatedFilters);
  };

  const getAmbassadors = (filters: AmbassadorExperienceFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (
        filters[key] !== undefined &&
        filters[key] !== null &&
        filters[key] !== ""
      ) {
        filtersToSend[key] = filters[key];
      }
    }
    const queryParams = {
      ...filtersToSend,
      page: filters.page - 1,
      sortDir: 'DESC',
      sortBy: 'createdAt',
    };
    getAmbassadorExperiences(
      setData,
      queryParams,
      setFilters,
      setTotalElements
    );
  };

  useEffect(() => {
    getAmbassadors(filters);
  }, [debounceSearch]);

  const handleChangeFilter = (event: any) => {
    const {
      target: { name, value },
    } = event;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    const updatedFilters = buildUpdatedFilters(
      { [name]: trimmedValue as any },
      true
    );
    setFilters(updatedFilters);
    if (name === "nameOrEmail" && trimmedValue === "") {
      getAmbassadors(updatedFilters);
    }
  };

  const resetFilters = () => {
    const updatedFilters = buildUpdatedFilters(new AmbassadorExperienceFiltersDTO(), true);
    setFilters(updatedFilters);
    getAmbassadors(updatedFilters);
  };

  const handleSearch = (event: any) => {
    const { key } = event;
    if (key === "Enter") {
      const updatedFilters = buildUpdatedFilters({}, true);
      setFilters(updatedFilters);
      getAmbassadors(updatedFilters);
    }
  };

  const goToDetail = (userId: number) => {
    navigate(`${siteRoutes.viewAmbassadorExperiencesDetail}?id=${userId}`);
  };
  return (
    <div>
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold ">
        Ambassador Experiences
      </h1>
      <div className="flex flex-wrap justify-between items-center gap-5 my-6">
        <button
          onClick={() => {
            navigate(siteRoutes.createAmbassadorExperience);
          }}
          className="px-4 py-2 text-sm bg-goldenOrangeBg text-white rounded-lg font-semibold"
        >
          Add Ambassador Experience
        </button>

        {/* <div className="w-full sm:w-[388px] relative">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primaryText text-lg" />
          <input
            type="search"
            placeholder="Search by Name or Email"
            value={filters.nameOrEmail}
            onChange={handleChangeFilter}
            onKeyUp={handleSearch}
            name="nameOrEmail"
            className="w-full search-input pl-10 p-2 border-[0.6px] border-borderLightGray rounded-full focus:outline-none bg-coolLightGrayBg"
          />
        </div> */}
      </div>

      <div className="bg-coolLightGrayBg border  border-borderLightGray p-4 rounded-lg w-full my-6">
        <div className="w-full overflow-x-auto scrollbar-hidden">
          <div className="flex flex-wrap sm:flex-nowrap lg:justify-end items-center gap-3">

            {/* Event Type  */}
            <select
              value={filters.eventType}
              onChange={handleChangeFilter}
              name="eventType"
              className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm bg-white h-[46px] w-full sm:w-auto min-w-[140px]"
            >
              <option value="">Event Type</option>
              <option value="TRAINING">Training</option>
              <option value="WELCOME">Welcome</option>
            </select>

            {/* Apply Filters Button */}
            <button
              onClick={() => {
                const updatedFilters = buildUpdatedFilters({}, true);
                setFilters(updatedFilters);
                getAmbassadors(updatedFilters);
              }}
              className="px-4 py-2 bg-darkTealBlue text-white rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
            >
              Apply Filters
            </button>

            {/* Clear Filters Button */}
            <button
              onClick={resetFilters}
              className="px-4 py-2 bg-techGlowBg text-primaryText rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
            >
              Clear Filter
            </button>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col gap-4">
        <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
          <table className="min-w-full divide-y divide-mediumGrayBorder">
            {/* Table Header */}
            <thead className="bg-white">
              <tr className="text-left">
                {columns.map((column, index) => {
                  return (
                    <th
                      className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                      key={index}
                    >
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="bg-white divide-y divide-mediumGrayBorder">
              {data.map((event: any, index: number) => (
                <tr key={index} className="hover:bg-gray-50 ">
                  <td className="px-4 py-4">
                    <img
                      className="rounded-full w-9 h-9 object-cover"
                      src={
                        event?.media && event.media.length > 0
                          ? concatPathWithBackendUrl(event.media[0].name)
                          : editProfilePicUser
                      }
                      alt={event.name}
                    />
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {event.name}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-normal max-w-xs truncate">
                    {event.description}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      event.eventType === 'TRAINING' 
                        ? 'bg-blue-100 text-blue-800' 
                        : event.eventType === 'WELCOME'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {event.eventType === 'TRAINING' ? 'Training' : 
                       event.eventType === 'WELCOME' ? 'Welcome' : 
                       event.eventType || 'N/A'}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {new Date(event.start).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {new Date(event.start).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })} - {new Date(event.end).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>

                  <td className="px-4 py-4 text-sm font-semibold whitespace-nowrap">
                    <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                      {event.subscriptions.length}
                    </span>
                  </td>

                  <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                    <div className="flex justify-start gap-2 cursor-pointer">
                      <span className="">
                        <button
                          onClick={() => goToDetail(event.id)}
                          className=""
                        >
                          <EyeIcon />
                        </button>
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Fragment>
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > 0 && (
            <Pagination
              count={totalElements}
              page={filters.page}
              limit={filters.limit}
              onPageChange={onPageChange}
            />
          )}
        </Fragment>
      </div>
    </div>
  );
};

export default AmbassadorExperiencesListing;
